import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { gmapApi } from 'vue2-google-maps';
import gMapStyles from '@/assets/json/gmapstyles.json';

export default {
  name: 'lrsMap',
  components: {

  },
  props: {
    dataObj: {
      type: Object,
    },
    //jobcardId: {
    //  type: Number,
    //  required: true
    //},
    //elementTypeId: {
    //  type: Number,
    //  required: true
    //},
    //elementId: {
    //  type: Number,
    //  required: true
    //},
    //eventId: {
    //  type: Number,
    //  required: true
    //},
    //eventTypeId: {
    //  type: Number,
    //  required: true
    //},
  },
  data: function () {
    return {
      center: { lat: 0, lng: 0 },
      gMapPositions: [
        { lat: 0, lng: 0, label: this.$t('lrs.startPoint') },
        { lat: 0, lng: 0, label: this.$t('lrs.endPoint') }
      ],
      markerTitle: this.$t('lrs.markerTitle'),
      selectedType: {},
    }
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    selectedType: function (value) {
      this.dataObj.lrsEventTypeId = value.id;
    }
  },
  created() {
    var geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    this.init();
  },
  methods: {
    init() {
      if (this.dataObj.lrsEventTypeId <= 0) {
        this.selectedType = this.dataObj.availableLrsEventTypes[this.dataObj.elementTypeId][0];
      }

      Vue.nextTick(() => {
        if (this.dataObj.lrsEventTypeId > 0 && this.dataObj.lrsEventId > 0) {
          this.get();
        } else {
          this.getGeoLocation();
        }

        /*if (this.gMapPositions[0].lat === 0)
          this.getGeoLocation();*/

        
      });
    },
    getGeoLocation() {
      if (this.selectedType.isPointEvent) {
        this.gMapPositions.splice(1, 1);
      }

      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        this.gMapPositions[0] = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        if (!this.selectedType.isPointEvent) {
          this.gMapPositions[1] = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        }
      });
    },
    gMapDragEnd(evnt, idx) {
      this.gMapPositions[idx].lat = evnt.lat();
      this.gMapPositions[idx].lng = evnt.lng();
    },
    createOrUpdate() {
      let points = [];

      for (var i = 0; i < this.gMapPositions.length; i++) {
        points.push({
          X: this.gMapPositions[i].lat,
          Y: this.gMapPositions[i].lng
        });
      }

      const params = {
        typeId: this.dataObj.lrsEventTypeId,
        eventId: this.dataObj.lrsEventId == -1 ? 0 : this.dataObj.lrsEventId,
        eventName: this.dataObj.jobcardId,
        elementId: this.dataObj.elementId,
        sourceId: this.dataObj.jobcardId,
        sourceType: 1,
        connectivityType: 0,
        points: points,
        StartDate: new Date(),
        EndDate: new Date()
      };

      axios.post('/LrsEvent/CreateOrUpdate', params)
        .then(response => {
          this.dataObj.lrsEventTypeId = response.data.typeId;
          this.dataObj.lrsEventId = response.data.eventId;

          this.setLrsEvent(response.data.typeId, response.data.eventId);
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        })
    },
    setLrsEvent(typeId, eventId) {
      const params = {
        ApplicationId: this.dataObj.appId,
        ApplicationKey: this.dataObj.appKey,
        LrsEventTypeId: typeId,
        LrsEventId: eventId
      };

      axios.post('/OmJobcardActivity/SetLrsEvent', params)
        .then(response => {
          this.$parent.showMapDialog = false;
          this.$alertMsg(this.$t('lrs.savedSuccessfully'), 2);
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        })
    },
    get() {
      axios.get('/LrsEvent/Get?typeId=' + this.dataObj.lrsEventTypeId + '&eventId=' + this.dataObj.lrsEventId)
        .then(response => {
          if (this.selectedType.isPointEvent) {
            this.center = {
              lat: response.data.points[0].x,
              lng: response.data.points[0].y
            };

            this.gMapPositions[0] = {
              lat: response.data.points[0].x,
              lng: response.data.points[0].y
            };
          } else {
            this.center = {
              lat: (response.data.points[0].x + response.data.points[1].x) / 2,
              lng: (response.data.points[0].y + response.data.points[1].y) / 2
            };

            this.gMapPositions[0] = {
              lat: response.data.points[0].x,
              lng: response.data.points[0].y
            };

            this.gMapPositions[1] = {
              lat: response.data.points[1].x,
              lng: response.data.points[1].y
            };
          }

          

        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        })
    },
  }
}

